import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import KIcon from '@kso/ui/lib/Icon';
import '@kso/ui/lib/Icon/style.css';
import Emitter from 'element-ui/lib/mixins/emitter';
import ElMenu from 'element-ui/lib/menu';
import 'element-ui/lib/theme-chalk/menu.css';
import ElMenuItem from 'element-ui/lib/menu-item';
import 'element-ui/lib/theme-chalk/menu-item.css';
import VueAbbr from '@kso/ui/lib/VueAbbr';
import '@kso/ui/lib/VueAbbr/style.css';
import { fetchGroupFiles, fetchFavors, fetchJoinedCompanies } from '@kso/ui/lib/request';
import { t } from '@kso/ui/lib/config/locale';
import ElTooltip from 'element-ui/lib/tooltip';
import 'element-ui/lib/theme-chalk/tooltip.css';
import cookie from 'cookie';

var FinderAside = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-finder-aside",
      "class": {
        'upload': _vm.isSelectFile
      }
    }, [_c('div', {
      staticClass: "k-finder-aside-wrap"
    }, [_c('el-menu', {
      ref: "menu",
      staticClass: "k-finder-aside-box",
      attrs: {
        "defaultActive": _vm.activeRoute
      },
      on: {
        "select": _vm.handleSelect
      }
    }, [_vm.isSelectFile && _vm.showTab('Latest') ? _c('el-menu-item', {
      attrs: {
        "index": "Latest"
      }
    }, [_c('KIcon', {
      staticClass: "normal-icon",
      attrs: {
        "type": "aside-latest"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang_latest))])], 1) : _vm._e(), _vm._v(" "), _vm.isAsideStar && _vm.showTab('Tags') ? _c('el-menu-item', {
      attrs: {
        "index": "Tags"
      }
    }, [_c('KIcon', {
      staticClass: "normal-icon",
      attrs: {
        "type": "aside-star"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang_star))])], 1) : _vm._e(), _vm._v(" "), _vm.isSharing && !_vm.isOldCompany && _vm.showTab('Sharing') ? _c('el-menu-item', {
      attrs: {
        "index": "Sharing",
        "disabled": _vm.disabledItem('Sharing')
      }
    }, [_c('KIcon', {
      staticClass: "normal-icon",
      attrs: {
        "type": "share1"
      }
    }), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "disabled": !_vm.disabledItem('Sharing') || !_vm.limitedCompany.tips,
        "popperClass": "k-finder-disabled-tips right",
        "effect": "dark",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "content",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('span', [_vm._v(_vm._s(_vm.limitedCompany.tips))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang_share1))])])], 1) : _vm._e(), _vm._v(" "), _vm.isAlls && _vm.showTab('All') ? _c('el-menu-item', {
      attrs: {
        "index": "All",
        "disabled": _vm.disabledItem('All')
      }
    }, [_c('KIcon', {
      staticClass: "normal-icon",
      attrs: {
        "type": "all-s"
      }
    }), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "disabled": !_vm.disabledItem('All') || !_vm.limitedCompany.tips,
        "popperClass": "k-finder-disabled-tips right",
        "effect": "dark",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "content",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('span', [_vm._v(_vm._s(_vm.limitedCompany.tips))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang_alls))])])], 1) : _vm._e(), _vm._v(" "), _vm.showTab('myTeams') && _vm.showMyTeamTab ? _c('el-menu-item', {
      attrs: {
        "index": "MyTeams",
        "disabled": _vm.disabledItem('myTeams')
      }
    }, [_c('KIcon', {
      staticClass: "normal-icon",
      attrs: {
        "type": "myTeam-s",
        "issvg": true
      }
    }), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "disabled": !_vm.disabledItem('myTeams') || !_vm.limitedMyTeams.tips && !_vm.limitedCompany.tips,
        "popperClass": "k-finder-disabled-tips right",
        "effect": "dark",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "content",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('span', [_vm._v(_vm._s(_vm.limitedMyTeams.tips || _vm.limitedCompany.tips))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang_my_teams))])])], 1) : _vm._e(), _vm._v(" "), _vm.showTab('Enterprise') ? _vm._l(_vm.joinedCompanies, function (item, id) {
      return _c('el-menu-item', {
        key: id,
        staticClass: "enterprise-menu",
        "class": {
          'is-active': "Enterprise_" + item.corpid === _vm.activeRoute,
          'is-disabled': _vm.disabledItem('Enterprise', item)
        },
        attrs: {
          "index": "Enterprise_" + item.corpid
        },
        on: {
          "click": function click() {
            return _vm.handleSelect('Enterprise', item);
          }
        }
      }, [_c('KIcon', {
        staticClass: "normal-icon",
        attrs: {
          "type": "enterprise"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "enterprise-name"
      }, [_c('el-tooltip', {
        attrs: {
          "disabled": !_vm.disabledItem('Enterprise', item) || !_vm.limitedCompany.tips,
          "popperClass": "k-finder-disabled-tips right",
          "effect": "dark",
          "placement": "right"
        }
      }, [_c('span', {
        staticClass: "content",
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('span', [_vm._v(_vm._s(_vm.limitedCompany.tips))])]), _vm._v(" "), _c('vue-abbr', {
        attrs: {
          "text": item.name
        }
      })], 1)], 1)], 1);
    }) : _vm._e()], 2), _vm._v(" "), _vm.favors.length && _vm.showTab('Favorite') ? _c('div', {
      staticClass: "el-menu k-finder-aside-box"
    }, _vm._l(_vm.favors, function (favor, id) {
      return _c('div', {
        key: id,
        staticClass: "el-menu-item",
        "class": {
          'is-disabled': _vm.disabledItem('Favorite', favor)
        },
        on: {
          "click": function click() {
            return _vm.handleSelect('Favorite', favor);
          }
        }
      }, [favor.ftype === 'folder' ? _c('KIcon', {
        staticClass: "normal-icon",
        attrs: {
          "type": "folder-s-selected"
        }
      }) : favor.ftype === 'team' ? _c('KIcon', {
        staticClass: "normal-icon",
        attrs: {
          "type": "dialog-team-folder-s"
        }
      }) : favor.ftype === 'linkfolder' ? _c('KIcon', {
        staticClass: "normal-icon",
        attrs: {
          "type": "dialog-team-folder-s"
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "favor-name"
      }, [_c('el-tooltip', {
        attrs: {
          "disabled": !_vm.disabledItem('Favorite', favor) || !_vm.limitedCompany.tips,
          "popperClass": "k-finder-disabled-tips right",
          "effect": "dark",
          "placement": "right"
        }
      }, [_c('span', {
        staticClass: "content",
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('span', [_vm._v(_vm._s(_vm.limitedCompany.tips))])]), _vm._v(" "), _c('vue-abbr', {
        attrs: {
          "text": favor.name
        }
      })], 1)], 1)], 1);
    }), 0) : _vm._e()], 1), _vm._v(" "), _vm.showUpload ? _c('div', {
      staticClass: "k-finder-aside-local plupload-anchor"
    }, [_c('KIcon', {
      attrs: {
        "type": "local-file"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "local-file-text"
    }, [_vm._v(_vm._s(_vm.lang_localfile))])], 1) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'KFinderAside',
  components: {
    // KButton,
    KIcon: KIcon,
    ElMenu: ElMenu,
    ElMenuItem: ElMenuItem,
    VueAbbr: VueAbbr,
    ElTooltip: ElTooltip
  },
  mixins: [Emitter],
  props: {
    source: {
      type: Object
    },
    user: {
      type: Object
    },
    src: {
      type: String
    },
    isSelectFile: {
      type: Boolean
    },
    showUpload: {
      type: Boolean
    },
    actionType: {
      type: String
    },
    limitedCompany: {
      type: Object
    },
    limitedTabs: {
      type: Array
    },
    limitedMyTeams: {
      type: Object
    },
    showMyTeamTab: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      lang_latest: t('combine.aside.latest'),
      lang_star: t('combine.aside.star'),
      lang_my_teams: t('combine.aside.myTeams'),
      lang_alls: t('combine.aside.alls'),
      lang_share1: t('combine.aside.share1'),
      lang_localfile: t('combine.aside.localfile'),
      favors: [],
      joinedCompanies: [],
      company: []
    };
  },
  computed: {
    isAsideStar: function isAsideStar() {
      return this.$__SHIELD_CONFIG__ ? this.$__SHIELD_CONFIG__.UIFinderAsideStar : true;
    },
    isAlls: function isAlls() {
      if (this.user.is_company_account) {
        return false;
      }
      return this.$__SHIELD_CONFIG__ ? this.$__SHIELD_CONFIG__.UIFinderMyDocs : true;
    },
    isSharing: function isSharing() {
      return this.$__SHIELD_CONFIG__ ? this.$__SHIELD_CONFIG__.UIFinderAsideSharing : true;
    },
    activeRoute: function activeRoute() {
      var _ref = this.source || {},
        routeName = _ref.routeName,
        corpid = _ref.corpid;
      var index = routeName || '';
      if (index === 'Team' && this.src || index === 'Secret') {
        index = 'All';
      }
      var _lanStr = t('combine.aside.receive');
      var _receive = new RegExp(_lanStr);
      if (_receive.test(this.src)) {
        // 修复：正则表达式匹配变量错误，通过RegExp对象匹配
        index = 'Sharing';
      }

      // 我的团队
      var _langStrMyTeams = t('combine.aside.myTeams');
      var _myTeams = new RegExp(_langStrMyTeams);
      if (_myTeams.test(this.src)) {
        index = 'MyTeams';
      }
      if (index === 'Enterprise' && this.joinedCompanies.length) {
        index = "Enterprise_".concat(corpid); // 企业
      }
      return index;
    },
    isOldCompany: function isOldCompany() {
      var isPlus = this.user.is_plus;
      return !isPlus;
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Promise.all([_this.getFavors(), _this.getCompanies()]);
          case 3:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }))();
  },
  methods: {
    showTab: function showTab(tab) {
      if (this.limitedCompany.id && ['Tags', 'Favorite'].includes(tab)) {
        return false;
      }
      if (this.limitedTabs.length) {
        return this.limitedTabs.includes(tab);
      }
      return true;
    },
    disabledItem: function disabledItem(name, item) {
      if (this.limitedCompany.id) {
        if (['All', 'Sharing', 'myTeams'].includes(name)) {
          return true;
        } else if (!['Latest', 'Tags'].includes(name) && item) {
          return Number(item.corpid || item.id) !== Number(this.limitedCompany.id);
        }
      }
      return false;
    },
    handleSelect: function handleSelect(name, item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var source, groupid, linkgroupid, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              source = {};
              if (!_this2.disabledItem(name, item)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (!(name === 'Favorite')) {
                _context2.next = 11;
                break;
              }
              groupid = item.groupid, linkgroupid = item.linkgroupid;
              _context2.next = 7;
              return fetchGroupFiles(linkgroupid || groupid);
            case 7:
              data = _context2.sent;
              /* eslint-disable */
              item.currentTeam = data;
              /* eslint-disable */
              if (data.corpid > 0) {
                item.corpid = data.corpid;
              }
              if (item.corpid) {
                name = 'Enterprise';
              } else {
                name = 'Team';
              }
            case 11:
              if (~['Enterprise', 'Team'].indexOf(name)) {
                source = Object.assign({}, item);
              }
              if (~['Latest', 'Tags', 'All', 'Enterprise', 'Team', 'Sharing', 'MyTeams'].indexOf(name)) {
                source.routeName = name;
                _this2.dispatch('KFinder', 'source', source);
              }
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getFavors: function getFavors() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var favors, favorites, arr;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              favors = [];
              _context3.next = 3;
              return fetchFavors();
            case 3:
              favorites = _context3.sent;
              arr = favorites;
              arr.forEach(function (favor) {
                var file = {
                  id: favor.id,
                  groupid: favor.groupid,
                  parentid: favor.fileid,
                  name: favor.fname || favor.gname,
                  type: favor.fname ? favor.ftype : 'team',
                  key: favor.groupid + '_' + favor.fileid,
                  linkgroupid: favor.linkgroupid,
                  corpid: favor.corpid > 0 ? favor.corpid : 0 // 服务端由于线上已有缓存原因，只能将个人corpid设置为-1
                };
                arr.push(file);
              });
              favors = arr || [];
              favors = favors.filter(function (v) {
                return v.type === 'folder' || v.type === 'team' || v.type === 'linkfolder';
              });
              favors = favors.map(function (v) {
                return Object.assign({}, v, {
                  id: v.parentid,
                  parentid: 0,
                  ftype: v.type
                });
              });
              _this3.favors = favors;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var arr, _this4$user$corp, name, id;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetchJoinedCompanies();
            case 2:
              _this4.company = _context4.sent;
              arr = _this4.company;
              if (arr.length > 0) {
                arr = arr.map(function (c) {
                  return {
                    corpid: c.id,
                    name: c.name
                  };
                });
              } else if (_this4.user.corp) {
                _this4$user$corp = _this4.user.corp, name = _this4$user$corp.name, id = _this4$user$corp.id;
                arr = [{
                  name: name,
                  corpid: id
                }];
              }
              if (_this4.$__SHIELD_CONFIG__ && _this4.$__SHIELD_CONFIG__.isBeemwork) {
                arr = _this4.handleBeemworkAction(arr);
              }
              _this4.joinedCompanies = arr;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handleBeemworkAction: function handleBeemworkAction(arr) {
      var _this5 = this;
      var _arr = arr;
      var cookies = cookie.parse(document.cookie) || {};
      var orgId = cookies['__org_id'];
      if (orgId) {
        _arr = arr.filter(function (_ref2) {
          var corpid = _ref2.corpid;
          return Number(orgId) === corpid;
        });
        if (_arr && _arr[0]) {
          this.$nextTick(function () {
            setTimeout(function () {
              _this5.handleSelect('Enterprise', {
                corpid: Number(orgId),
                name: _arr[0].name
              });
            }, 2);
          });
        } else {
          console.log('can not find target to be click from filted data');
        }
      } else {
        console.log('can not find any __org_id from cookies');
      }
      return _arr;
    }
  }
};

FinderAside.install = function (Vue) {
  Vue.component(FinderAside.name, FinderAside);
};

export { FinderAside as default };
